import { FC, PropsWithChildren } from "react";
import { useAppSelector } from "./store/store";

export const WithAuth: FC<PropsWithChildren> = ({ children }) => {
  const { accessToken } = useAppSelector((state) => state.app.wixUser);

  if (accessToken) {
    return <>{children}</>;
  }

  return <>Not authorized</>;
};

export const AppRoutes = {
  MAIN: {
    get: () => "/",
  },
  PRODUCT: {
    get: () => "/product/:productId",
    getComputed: (id: number) => `/product/${id}`,
  },
  WIX_EDITOR: {
    get: () => "/wix-editor",
  },
};
